import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface KubernetesListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class KubernetesListPage extends Component<KubernetesListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.kubernetes(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}